export default {
  your: ' ',
  editinfo: 'Edit',
  save: 'Save',
  reset: 'Cancellation',
  header1: 'Welcome back',
  header2: 'User level',
  header3: 'Total Funcoins',
  nav: {
    settings: 'Settings',
    profile: 'Personal information',
    accountset: 'Account Security',
    real: 'Real-name authentication',
    skill: 'Skill',
    checkin: 'Daily punch card',
    invite: 'Invite others'
  },
  profile: {
    uploadavatar: 'Upload a photo',
    username: 'Username',
    sex: 'Gender',
    male: 'Male',
    female: 'Female',
    birthday: 'Birthdate',
    location: 'Residence',
    nationality: 'Nationality',
    ethnicity: 'Ethnicity',
    whiteperson: 'White',
    yellowperson: 'Yellow',
    blackperson: 'Black',
    marriage: 'Marriage status',
    unmarry: 'Single',
    married: 'Married',
    monthertonue: 'Mother tongue',
    education: 'Education background',
    juniorschool: 'Junior high school degree',
    highschool: 'High school degree',
    juniorcollege: 'Undergraduate degree',
    regularcollege: 'Graduate degree',
    graduatestudent: 'Doctor degree',
    doctor: 'Post doctor',
    workStatus: 'Work status',
    oc1: 'employed',
    oc2: 'student',
    oc3: 'unemployed',
    oc4: 'freelance',
    oc5: 'stay at home mom',
    oc6: 'retirement',
    industry: 'Industry',
    industry0: 'None',
    industry1: 'Internet/IT/electronics/communication',
    industry2: 'Advertising/Media/Culture/Sports',
    industry3: 'Finance/Insurance',
    industry4: 'education/training',
    industry5: 'Transportation/Logistics',
    industry6: 'Pharmaceutical/Medical',
    industry7: 'Real Estate/Construction',
    industry8: 'Trade/Retail',
    industry9: 'Building Materials/Home Furnishing',
    industry10: 'Machinery/Manufacturing',
    industry11: 'Car',
    industry12: 'Service Industry',
    industry13: 'Professional Services',
    industry14: 'Energy/Chemical/Environmental Protection',
    industry15: 'Government/non-profit organization',
    industry16: 'Other',
    interest: 'Hobbies',
    interest1: 'Sports',
    interest2: 'Music',
    interest3: 'Musical instrument',
    interest4: 'Movies',
    interest5: 'Anime',
    interest6: 'Read',
    interest7: 'Game',
    interest8: 'Tourism',
    interest9: 'Other',
    js: {
      pleaseselect: 'Choose',
      error: {
        type1: 'Failure',
        type2: 'The photo must be jpg!',
        type3: 'The photo must be smaller than 2MB!'
      },
      success: 'Success '
    }
  },
  account: {
    password: 'Password',
    pwdchange: 'Change password',
    associate: 'Associate',
    associated: 'Associated',
    bind: 'Bind',
    unbind: 'Unbound',
    change: 'Change',
    changephone: 'Change phone num',
    changemail: 'Change mail',
    unassociated: 'Unassociated',
    developing: 'Developing',
    accountSet0: 'It is recommended that the password 8 length exceeds to keep your account safe',
    accountSet2: 'Logout',
    accountSet3: 'All your account information will be deleted from the platform',
    accountSet4: 'Logout',
    accountSet5: 'Account association',
    accountSet6: 'Payment binding'
  },
  real_from: {
    realname: 'Real name authentication',
    truename: 'Real name',
    idcrdnum: 'ID card number',
    idcardfront: 'Submit the front of ID card',
    idcardback: 'Submit the back of ID card',
    idcardhold: 'Photo of ID card',
    idcard: 'ID card ',
    idcard2: 'Front side  of photo of ID card(portrait side)',
    idcard3: 'Back side  of photo of ID card(national emblem side)',
    passport: 'Passport',
    company: 'Co.certification',
    passportNum: 'Passport number',
    passportImg: 'Photo of passport front page ',
    passport2: 'Portrait side of passport',
    company1: 'Name of juridical person',
    company2: 'ID number of juridical person',
    company3: 'Photo of ID card of juridical person',
    company4: 'Unified social credit code',
    company5: 'Enterprise business license',
    company6: 'Account number of Bank of deposite',
    company7: 'Bank of deposit permit',
    submit: 'Submit for review',
    js: {
      rules: {
        realName: 'Please enter the correct name',
        idCardNum1: 'Please enter the correct ID number',
        idCardNum2: 'Minimum 15 characters, maximum 18 characters',
        idCardFront: 'Please upload your ID headshot photo',
        idCardBack: 'Please upload a photo of the valid information side of your ID card',
        idCardHold: 'Please submit a selfie holding ID card',
        passportNum: 'Please enter your passport number',
        passportFront: 'Please upload passport photo'
      },
      error: {
        type1: 'Failure ',
        type2: ' The photo must be jpg!',
        type3: ' The photo must be smaller than 50MB!'
      },
      success: 'Success '
    },
    payAccount7: 'Payment method binding',
    payAccount8: 'Alipay account'
  },
  real: {
    realname: 'Real Name',
    reform: 'Recertification',
    truename: 'Real name: ',
    idcardnum: 'ID card number: ',
    passportNum: 'Passport number: ',
    status: 'Status: ',
    js: {
      realStatus1: 'Verifying',
      realStatus2: 'Passed',
      realStatus3: 'Refused'
    },
    realShow0: 'Denial Reason',
    realShow2: 'Legal Representative',
    realShow3: 'Legal ID number'
  },
  skill: {
    language: 'Languages',
    skillshow: 'Skill demonstration',
    skill1: 'All',
    skill2: 'Obtained',
    skill3: '查看勋章详情',
    skill4: 'Receive a medal',
    skill5: 'Start the exam',
    skill6: 'Medal Wall'
  },
  checkIn: {
    str1: 'Clock in',
    str2: 'Sign in today',
    str3: 'First day',
    day2: 'Second day',
    day3: 'Third day',
    day4: 'Fourth day',
    day6: 'Sixth day',
    day7: 'Seventh day',
    str4: 'Fifth day',
    str5: 'Click on',
    str6: 'Get rich rewards for one week of continuous clocking',
    str7: 'Sign in rules',
    str8: 'Continuous sign in, one week for a circle',
    str9: 'If discontinue, should start a new one week for a circle',
    str10: 'This event has nothing to do with the equipment manufacturer'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/user.js